module.exports = __webpack_public_path__ + "img/block-black.2724f645.svg";